/**
 * Urgent first, wherever tasks are listed (operator, 2026-10-11: "in all system
 * urgent tasks must be on the top"). The API orders every list this way
 * (`modules/tasks/task-order.ts`); the page needs the rule itself only where it
 * changes a list before the API answers — a card dropped on the board — and to
 * mark the tasks that rose.
 */

/** Not finished: Done and Cancelled are a task's end. */
const OPEN = ['TO_DO', 'IN_PROGRESS', 'BLOCKED', 'REVIEW'];

/** Urgent and still open: the tasks every list puts first. */
export function isOpenUrgent(task: { priority?: string | null; status: string }): boolean {
  return task.priority === 'URGENT' && OPEN.includes(task.status);
}

/** A list in its own order, with its open urgent tasks moved to the top. */
export function urgentFirst<T extends { priority?: string | null; status: string }>(tasks: T[]): T[] {
  return [...tasks.filter(isOpenUrgent), ...tasks.filter((task) => !isOpenUrgent(task))];
}
